import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/_core/global.service';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LangService {

  public lang = new BehaviorSubject<string>(null);


  constructor(
    private translateService: TranslateService,
    private global: GlobalService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) { }

  public setLang() {
    this.translateService.setDefaultLang(this.global.langs[0] + (!!this.global.propConfs$.coinSymbol ? ('-' + this.siteName().split('.')[0]) : ''));

    let user = JSON.parse(localStorage.u || '{}');

    if (this.global.langs.length > 1 && !!user.l && !!~this.global.langs.indexOf(user.l)) {
      this.lang.next(user.l);
      this.translateService.use(user.l + (!!this.global.propConfs$.coinSymbol ? ('-' + this.siteName().split('.')[0]) : ''));
      this.document.documentElement.lang = user.l;
      return user.l;
    } else {
      user.l = !!~this.global.langs.indexOf(navigator.language) ? navigator.language : this.global.langs[0];
      localStorage.u = JSON.stringify(user);
      this.lang.next(user.l);
      this.translateService.use(user.l);
      this.document.documentElement.lang = user.l;
      return user.l;
    }
  }

  public changeLang(lang, doReload: boolean = true) {
    let user = JSON.parse(localStorage.u || '{}');
    user.l = lang.replace('_', '-');
    this.translateService.use(user.l + (!!this.global.propConfs$.coinSymbol ? ('-' + this.siteName().split('.')[0]) : ''));
    this.lang.next(user.l);
    localStorage.u = JSON.stringify(user);
    this.document.documentElement.lang = user.l;

    if (doReload) {
      // setTimeout(() => { location.href = location.href }, 500);
      location.href = location.href;
      // location.href = `${location.protocol}//${location.hostname}:${location.port}`;
      // this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true, queryParamsHandling: "merge" }).then(() => { this.router.navigate([this.router.url], { queryParamsHandling: "merge" }) });
    }
  }

  private siteName(): string {
    let params = new URLSearchParams(location.search);
    if (!!~['localhost'].indexOf(location.hostname)) {
      if (params.has('portal')) {
        localStorage.p = params.get('portal');
        return params.get('portal');
      } else if (localStorage.p) {
        return localStorage.p;
      } else { return location.hostname }
    } else { return location.hostname }
  }
}
